import script from "./CoinSelectItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoinSelectItem.vue?vue&type=script&lang=ts&setup=true"

import "./CoinSelectItem.vue?vue&type=style&index=0&id=73a4fa59&lang=scss"

const __exports__ = script;

export default __exports__